import {
    ChangeDetectionStrategy,
    Component, DestroyRef,
    EventEmitter, inject,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import { FormControl } from '@angular/forms';
import {Observable} from 'rxjs';
import { filter } from 'rxjs/operators';
import * as RA from 'ramda-adjunct';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {LocationSetType} from '@emm/core/models/location-set-type.model';
import {FeatureScope} from '@emm/core/util/feature-scope.constants';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'emm-location-set-type-picker',
    styleUrls: ['./location-set-type-picker.component.scss'],
    templateUrl: './location-set-type-picker.component.html',
    standalone: false
})
export class LocationSetTypePickerComponent implements OnInit, OnChanges {

    @Input() locationSetTypes: LocationSetType[];
    @Input() disabled: boolean;
    @Input() selectedFeatureScope: string;
    @Input() selectedLocationSetType$: Observable<LocationSetType>;
    @Input() removeLocationsInGmb: boolean;

    @Output() locationSetTypeSelected = new EventEmitter<LocationSetType>();

    private readonly destroyRef: DestroyRef = inject(DestroyRef);
    locationSetTypeCtrl = new FormControl();
    locationSetTypesList: LocationSetType[];
    selectedLocationSetType;

    constructor() {}

    ngOnChanges(changes: SimpleChanges): void {

        if (changes['locationSetTypes'] || changes['removeLocationsInGmb'] || changes['selectedFeatureScope']) {
            this.updateLocationSetTypesList();
        }

        if (changes['selectedFeatureScope'] && !changes['selectedFeatureScope'].firstChange
            && this.selectedLocationSetType?.tag === 'LOCATION') {
            this.selectedLocationSetType = null;
            this.locationSetTypeCtrl.setValue(null, { emitEvent: false });
        }

        if (changes['disabled']) {
            if (this.disabled) {
                this.locationSetTypeCtrl.disable({ emitEvent: false });
                return;
            }
            this.locationSetTypeCtrl.enable({ emitEvent: false });
        }
    }

    private updateLocationSetTypesList(): void {
        if (!this.locationSetTypes) {
            return;
        }

        let filteredList = this.locationSetTypes.filter(locationSetType => locationSetType?.tag !== 'VENUE');

        if (this.selectedFeatureScope === FeatureScope.Client) {
            filteredList = this.locationSetTypes.filter(locationSetType => locationSetType?.tag === 'CHAIN');
        }

        // Filter out LOCATION option when feature flag is true and scope is Global
        if (this.removeLocationsInGmb && this.selectedFeatureScope === FeatureScope.Global) {
            filteredList = filteredList.filter(locationSetType => locationSetType?.tag !== 'LOCATION');
        }

        this.locationSetTypesList = filteredList;
    }

    ngOnInit(): void {
        this.locationSetTypeCtrl.valueChanges
            .pipe(filter(RA.isNotNil), takeUntilDestroyed(this.destroyRef))
            .subscribe(this.locationSetTypeSelected);
        try {
            if (this.locationSetTypeCtrl) {
                this.selectedLocationSetType$
                    .pipe(takeUntilDestroyed(this.destroyRef))
                    .subscribe((type: LocationSetType) => {
                    this.selectedLocationSetType = type;
                    this.locationSetTypeCtrl.setValue(type, {emitEvent: false});
                });
            }
        } catch (e) {
        }
    }

    get placeholderText(): string {
        return `Select Location Set Type`;
    }



}
